import { render, staticRenderFns } from "./FrmContactoList.vue?vue&type=template&id=578fed90&scoped=true&"
import script from "./FrmContactoList.vue?vue&type=script&lang=js&"
export * from "./FrmContactoList.vue?vue&type=script&lang=js&"
import style0 from "./FrmContactoList.vue?vue&type=style&index=0&id=578fed90&lang=scss&scoped=true&"
import style1 from "./FrmContactoList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "578fed90",
  null
  
)

export default component.exports